import { notification } from 'antd';
import { API_BASE_URL } from '../config';
import { UploadChangeParam, UploadFile } from 'antd/es/upload';
import { PageBody, PageHead } from '../layout';
import { UploadDropzone } from '../components/ui';

const UploadPrePicks = () => {
  function onChange(info: UploadChangeParam<UploadFile<any>>) {
    if (info.file.status === 'done') {
      notification.success({ message: 'Picks successfully uploaded.' });
    } else if (info.file.status === 'error') {
      notification.error({ message: 'Picks failed to upload.' });
    }
  }

  return (
    <>
      <PageHead title="Pre Picks" subtitle="Upload domains to pre-pick before the next run." />
      <PageBody>
        <div className="flex flex-col gap-4">
          <p className="text-text-2 text-[12.5px]">
            Drop a file with domains below to add them as pre-picks.
          </p>
          <UploadDropzone
            action={API_BASE_URL + '/v1/domainLeads/pre-picks'}
            onChange={onChange}
          />
        </div>
      </PageBody>
    </>
  );
};

export default UploadPrePicks;
